(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rxjs"), require("superagent"));
	else if(typeof define === 'function' && define.amd)
		define(["rxjs", "superagent"], factory);
	else if(typeof exports === 'object')
		exports["TimetrackerClient"] = factory(require("rxjs"), require("superagent"));
	else
		root["TimetrackerClient"] = factory(root["rxjs"], root["superagent"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimetrackerClient = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rxjs = __webpack_require__(1);

var _sendPing = __webpack_require__(2);

var _sendPing2 = _interopRequireDefault(_sendPing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Both in milliseconds. Should be the same values as used in the timetracker
// backend; see its documentation (https://github.com/datacamp/timetracker).
var INACTIVITY_TIMEOUT = 30 * 1000;
var PING_INTERVAL = 10 * 1000;

// DOM events signalling user activity.
var inputEventTypes = ["mousemove", "click", "keydown", "DOMMouseScroll", "mousewheel", "scroll", "touchstart", "touchmove"];

var TimetrackerClient = exports.TimetrackerClient = function () {
  function TimetrackerClient(timetrackerURL, appName) {
    var _this = this;

    _classCallCheck(this, TimetrackerClient);

    this.timetrackerURL = timetrackerURL;
    this.appName = appName;
    this.userId = undefined;
    this.manuallyActiveSubject = new _rxjs.Subject();
    this.contentIdSubject = new _rxjs.Subject();

    this.userActivity$ = _rxjs.Observable.from(inputEventTypes).mergeMap(function (eventType) {
      if (typeof document !== "undefined") return _rxjs.Observable.fromEvent(document, eventType);
      return [];
    }).merge(this.manuallyActiveSubject).throttleTime(500);

    this.userBecomesInactive$ = this.userActivity$.startWith(0).switchMapTo(_rxjs.Observable.timer(INACTIVITY_TIMEOUT));

    this.userWakesUp$ = this.userBecomesInactive$.switchMapTo(this.userActivity$.first());

    this.timetrackerObservable = this.contentIdSubject.merge(this.userWakesUp$).switchMapTo(_rxjs.Observable.timer(0, PING_INTERVAL).takeUntil(this.userBecomesInactive$)) // == ping$
    .withLatestFrom(this.contentIdSubject, function (time, contentIDs) {
      return contentIDs;
    }).do(function (contentIDs) {
      var primaryId = contentIDs.primaryId,
          secondaryId = contentIDs.secondaryId,
          tertiaryId = contentIDs.tertiaryId;

      (0, _sendPing2.default)({
        url: _this.timetrackerURL,
        appName: _this.appName,
        userId: _this.userId,
        primaryId: primaryId,
        secondaryId: secondaryId,
        tertiaryId: tertiaryId
      });
    });

    this.subscription = this.timetrackerObservable.subscribe(function () {});
  }

  _createClass(TimetrackerClient, [{
    key: "startTracking",
    value: function startTracking(primaryId, secondaryId, tertiaryId) {
      if (!this.userId) return; // can't track until userId is set
      this.contentIdSubject.next({ primaryId: primaryId, secondaryId: secondaryId, tertiaryId: tertiaryId });
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      this.userId = userId;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscription.unsubscribe();
    }
  }]);

  return TimetrackerClient;
}();

exports.default = TimetrackerClient;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendPing = undefined;

var _superagent = __webpack_require__(3);

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sendPing = exports.sendPing = function sendPing(_ref) {
  var url = _ref.url,
      appName = _ref.appName,
      userId = _ref.userId,
      primaryId = _ref.primaryId,
      secondaryId = _ref.secondaryId,
      tertiaryId = _ref.tertiaryId;

  var data = {
    app_name: appName,
    user_id: userId,
    primary_id: primaryId,
    secondary_id: secondaryId,
    tertiary_id: tertiaryId
  };
  var headers = { "Content-Type": "application/json" };
  var request = _superagent2.default.post(url + "/timetrack").send(data).set(headers);
  request.end(function () {});
};

exports.default = sendPing;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ })
/******/ ]);
});